import React from 'react';
import './App.css';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { ShopifyQuestionnaire } from './components/ShopifyQuestionnaire';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <Hero />
              <Services />
              <WhyChooseUs />
              <ContactForm />
              <Footer />
            </>
          } />
          <Route path="/shopify-questionnaire" element={<ShopifyQuestionnaire />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;